export default {"src":"/_next/static/media/search.ac6d8e7e.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};